<template>
  <Modal :id="'cmp-catalog-licence-add-account'" @cancelled="onCancel">
    <template slot="header">
      {{ $t("print_delivery") }}
    </template>
    <template slot="body">
      <!-- <TextField
        class="m1"
        :id="'start_date'"
        required
        type="date"
        v-bind="textFieldConfig"
        :value="start_date"
        :placeholder="$t('start_date')"
        @valuechanged="onTextFieldValueChange"
        @validated="onValidation"
      /> -->

      <TextField
        type="date"
        :id="'start_date'"
        class="m1"
        required
        :placeholder="`${$t('start_date')}`"
        :value="start_date"
        v-bind="textFieldConfig"
        @valuechanged="onDateChange"
        @validated="onValidation"
      />
      <TextField
        type="date"
        :id="'end_date'"
        class="m1"
        required
        :placeholder="`${$t('end_date')}`"
        :value="start_date"
        v-bind="textFieldConfig"
        @valuechanged="onDateChange"
        @validated="onValidation"
      />

      <Dropdown
        :id="'booking_template_id'"
        class="m2"
        required
        :options="templateTV"
        :selected="templateTV.find((x) => x.value == booking_template_id)"
        :placeholder="$t('template')"
        box
        deselect
        :showValidationIcons="true"
        :immediateValidation="true"
        @selectedChange="(e) => onDropdownChange('booking_template_id', e)"
        @validated="(e) => onDropdownValidation('booking_template_id', e)"
      />
      <!-- <Dropdown
           required
           :showValidationIcons="true"
           :immediateValidation="true"
           :id="'accounting_period'"
           class="m2"
           :options="accountingPeriodTV"
           :selected="
              accountingPeriodTV.find(
                (x) => x.value == licenceObject.accounting_period
              )
            "
            :placeholder="$t('accounting')"
           box
           deselect
           @selectedChange="(e) => onDropdownChange('accounting_period', e)"
           @validated="(e) => onValidation('accounting_period', e)"
        />  -->
    </template>
    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">
        {{ $t("cancel") }}
      </button>
      <button
        class="dt-button v1 with-ico"
        :class="{ disabled: okButtonDisabled }"
        :disabled="okButtonDisabled"
        @click.stop="onOKClick"
      >
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";

import { createTV, tv } from "../../../../models/text-value.model";
import { format } from "date-fns";
export default {
  components: {
    Modal,
  },
  props: {
    templateArray: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  data: () => ({
    textFieldConfig: {
      height: 42,
      showEditIconOnHover: false,
      box: true,
      showValidationIcons: true,
      immediateValidation: true,
    },

    start_date: format(new Date(), "YYYY-MM-DD"),
    end_date: format(new Date(), "YYYY-MM-DD"),
    booking_template_id: null,

    // licenceStatuses:[],
    validationResult: {},

    formSubmitLoading: false,
  }),
  computed: {
    isFormValid: function () {
      return Object.values(this.validationResult).every((e) => e?.valid);
    },
    templateTV: function () {
      return createTV(
        this.templateArray,
        "booking_template_name",
        "booking_template_id"
      );
    },

    okButtonDisabled: function () {
      return !this.isFormValid && this.formSubmitLoading;
    },
  },
  methods: {
    onValidation: function (name, value) {
      this.$set(this.validationResult, name, value);
      console.log(this.validationResult);
    },
    onDropdownValidation(name, value) {
      this.$set(this.validationResult, name, value);
    },
    onDateChange: function (name, value) {
      this[name] = value;
    },
    onDropdownChange: function (name, value) {
      // <-- Normal Form Handling Methods
      this[name] = value.value;
      console.log(name, value, this[name]);
    },
    onOKClick: function () {
      this.formSubmitLoading = true;
      this.$emit("onPrintDelivery", {
        start_date: this.start_date,
        end_date: this.end_date,
        booking_template_id: this.booking_template_id,
      });
      this.formSubmitLoading = false;
      this.$emit("cancelled", true);
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },

    //MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-licence-add-account {
}
</style>